import { Col, Flex, Row, Steps } from 'antd';
import { Subtitle, Text } from 'components/mvp-typography';
import { halfCol } from 'lib/utils/antd';

export function UserKnowledgePanel() {
  return (
    <Flex vertical gap={16} style={{ width: '100%' }}>
      <Flex vertical gap={'small'}>
        <Subtitle>What is this page?</Subtitle>
        <Text>
          This page is for managing ConcussionRx assessments for a specific
          test-taker. You can see whether the assessment is pending, activated,
          or expired. You can generate a new link at any time. Only one active
          link can exist at any time.
        </Text>
      </Flex>
      <Row>
        <Col {...halfCol}>
          <Flex vertical gap={'small'}>
            <Subtitle>What steps do I need to take?</Subtitle>
            <Steps
              size="small"
              current={-1}
              direction="vertical"
              style={{ padding: 8 }}
              progressDot
              items={[
                {
                  title: 'Generate a link',
                  description:
                    'Click the "Create link" button in the panel below.'
                },
                {
                  title: 'Send the link',
                  description:
                    'Copy the URL that appears, and send it to the test-taker using your regular contact methods.'
                },
                {
                  title: 'Analyze the results',
                  description:
                    'Available after the test-taker completes their assessment.'
                }
              ]}
            />
          </Flex>
        </Col>
        <Col {...halfCol}>
          <Flex vertical gap={'small'}>
            <Subtitle>What steps does my test-taker need to take?</Subtitle>
            <Steps
              size="small"
              current={-1}
              style={{ padding: 8 }}
              direction="vertical"
              progressDot
              items={[
                {
                  title: 'Open the link',
                  description:
                    'The test-taker will be prompted to setup their account, or automatically signed in if they have completed this step before.'
                },
                {
                  title: 'Complete the assessment',
                  description: 'The assessment expires after 72 hours.'
                },
                {
                  title: 'Assessment completed',
                  description:
                    'Once completed, the link will expire. A new link is required for future assessments.'
                }
              ]}
            />
          </Flex>
        </Col>
      </Row>
    </Flex>
  );
}
